import {ContentFeed, ColumnDataType} from 'common/src/modules/contentFeeds/contentFeeds.types';

/**
 * Validates persona column values in draft item column data.
 * Returns an error message if invalid, or null if all persona values are valid.
 */
function validatePersonaColumnValues(
  feed: ContentFeed,
  columnValues: Record<string, string> | null | undefined,
): string | null {
  if (!columnValues) return null;

  const personaColumnKeys = new Set(
    feed.feedColumnsSchema?.columns
      ?.filter((c) => c.type === ColumnDataType.Persona)
      .map((c) => c.columnKey) ?? [],
  );

  if (personaColumnKeys.size === 0) return null;

  const briefPersonaIds = new Set(feed.brief?.personaIds ?? []);

  for (const [key, value] of Object.entries(columnValues)) {
    if (!personaColumnKeys.has(key) || !value) continue;

    const parsed = Number(value);

    if (!Number.isInteger(parsed)) {
      return `Persona column '${key}' value must be a numeric persona ID, got '${value}'.`;
    }

    if (!briefPersonaIds.has(parsed)) {
      const available = [...briefPersonaIds].join(', ') || 'none';
      
      return `Persona column '${key}': persona ID ${parsed} is not in this feed's brief. Available persona IDs: ${available}.`;
    }
  }

  return null;
}

export default validatePersonaColumnValues;
